import './App.css';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'

import { Wallet } from './WalletAdapter.js';

function App() {
  return <Wallet />
}

export default App;